import React, { Component } from 'react'
import Smudgepainting from './project/Smudge_painting'
import Dailyui from './project/Daily_ui'
import Photomanipulation from './project/Photo_manipulation'
import Digitalpainting from './project/Digital_painting'
import Fontography from './project/Fontography'
import Isometric from './project/Isometric'
import Infographics from './project/Infographics'
import Illustration from './project/Illustration'
import Logo from './project/Logo'
import Icon from './project/Icon'
import Brand from './project/Brand'
import Gif from './project/Gif'

export default class Dailyproject_page extends Component {

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    tilte = () => {
        const pathname = this.props.location.pathname;
        const index = pathname.lastIndexOf('/');
        const fileName = pathname.substring(index + 1);
        // console.log(fileName)
        return fileName
    }

    fun =() => {
        const pathname = this.props.location.pathname;
        const index = pathname.lastIndexOf('/');
        const fileName = pathname.substring(index + 1);
        if(fileName === "Smudge painting"){
            return <Smudgepainting />
        }
        if(fileName === "Digital painting"){
            return <Digitalpainting />
        }
        if(fileName === "Daily ui"){
            return <Dailyui />
        }
        if(fileName === "Photo manipulation"){
            return <Photomanipulation />
        }
        if(fileName === "Fontography"){
            return <Fontography />
        }
        if(fileName === "Isometric"){
            return <Isometric />
        }
        if(fileName === "Infographics"){
            return <Infographics />
        }
        if(fileName === "Illustration"){
            return <Illustration />
        }
        if(fileName === "Logo"){
            return <Logo />
        }
        if(fileName === "Icon"){
            return <Icon />
        }
        if(fileName === "Brand"){
            return <Brand />
        }
        if(fileName === "Gif"){
            return <Gif />
        }
        else if(fileName === ""){
            return "404"
        }
    }
      
    render() {
        return (
            <div className="container-fluid px-sm-5 px-4 pt-5">
                <div className="row px-2"  id="heading">
                    <p>
                        <span className="display-4 fopri">{this.tilte()}</span>
                    </p>
                </div>
                {this.fun()}
            </div>
)
   }
}
